/**
 * Created by jonas on 2019-08-21.
 */
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";

export interface HarlequinWinRatioConfig extends IWinRatioConfig {

    readonly endSound?:string;
    readonly startSound?:string;
    readonly music?:string;

}


import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class BigWinStep implements GameRoundPresentation {

    stagger?:number;
    abortStagger?:number;
    private _fromRatioConfig:IWinRatioConfig;
    private _toRatioConfig:IWinRatioConfig;
    private _hasWin:boolean;
    private _countFrom:number;
    private _countTo:number;
    private _lastLevel:boolean;
    private _lastLevelCount:number;
    private _lastLevelRemainderRatio:number;
    private _aborted:boolean = false;
    private _currentRatio:number;
    private _currentLevel:number;
    private _tl:Timeline;
    private _data:ParsedGameData;
    //private _ease:CustomEase;


    constructor(fromRatioConfig:IWinRatioConfig, toRatioConfig:IWinRatioConfig, stagger?:number, abortStagger?:number, currentLevel?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this._fromRatioConfig = fromRatioConfig;
        this._toRatioConfig = toRatioConfig;
        this._currentLevel = currentLevel || 1;
    }

    public prepare(data:ParsedGameData):void {
        this._aborted = false;
        this._hasWin = false;
        this._countFrom = 0;
        this._countTo = 0;
        this._lastLevel = false;
        this._lastLevelCount = 0;
        this._lastLevelRemainderRatio = 0;
        this._data = data;

        if(data instanceof ParsedGameData) {
            if(data.singleWin <= 0) {
                return;
            }

            const currentWinRatio = data.singleWin / data.playedBetValue;
            this._currentRatio = currentWinRatio;
            this._hasWin = currentWinRatio >= this._toRatioConfig.ratio;
            this._countFrom = data.playedBetValue * this._fromRatioConfig.ratio;
            this._countTo = data.playedBetValue * this._toRatioConfig.ratio;
            if(data.currentWinRatioConfig && data.currentWinRatioConfig == this._toRatioConfig) {
                this._lastLevel = true;
                this._lastLevelCount = data.singleWin;
                const remainder:number = this._lastLevelCount - this._countTo;
                this._lastLevelRemainderRatio = remainder / data.playedBetValue;

                this._countTo =  this._lastLevelCount;
            }
        }
    }

    private startCountUpSound():void{
       SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_COUNTUP, 1000);
    }
    private endCountUpSound():void{
        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_COUNTUP, 1000);
    }
    private startBigWinMusicLoop(){
        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN, 1000);
    }

    public getAnimation(data:ParsedServerData):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        if(this._aborted && this._currentLevel === 1) {
            return null;
        }

        const tl:TimelineLite = new TimelineLite();
        const winTextStart:TimelineLite = HarlequinGameModuleConfig.winTextView.getStartAnimation(this._toRatioConfig,undefined, undefined, this._currentLevel);
        let count:TimelineLite = new TimelineLite();


        if(this._currentLevel <= 1) {
            tl.add([
                winTextStart,
                () => this.startBigWinMusicLoop()
            ]);
            tl.add([
                HarlequinGameModuleConfig.countUpView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration, undefined, 15),
                ()=>this.startCountUpSound()
            ], 0.536);
        }

        tl.add([

            (this._currentLevel > 1)? () => count = HarlequinGameModuleConfig.countUpView.getWinStepAnimation(this._countFrom, this._countTo, this._toRatioConfig.duration, undefined, 15) : () => {},
            (this._currentLevel > 1)? winTextStart : () => {},
            () => {
                if(this._currentLevel <= 1) {
                    console.log("BW LEVEL 1");
                }
                if(this._currentLevel > 1) {
                    console.log("BW LEVEL 2 and 3");
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_LEVEL_2_3);
                }
            },
            (this._currentLevel > 1)? count : () => {}
        ], 0);


        //if (!this._lastLevel){
            const winTextEnd:TimelineLite = HarlequinGameModuleConfig.winTextView.getEndAnimation(this._toRatioConfig);
            tl.add(winTextEnd,tl.totalDuration() - winTextEnd.duration());
       // }

        this._tl = tl;
        return tl;
    }

    public abort(isActive:boolean):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        if(this._currentLevel === 1) {
                this._tl.pause();
                this._tl.kill();
                this._aborted = true;
                const tl:TimelineLite = new TimelineLite();


                if(this._currentRatio <= 15) {
                    const winTextStart: TimelineLite = HarlequinGameModuleConfig.winTextView.getStartAnimation(this._toRatioConfig, undefined, undefined, this._currentLevel, "Big Win");
                    tl.add([
                        () => winTextStart,
                        () => this.startBigWinMusicLoop()
                    ]);
                }

                if(this._currentLevel === 1) {
                    tl.add([
                        () => SlotGame.sound.fadeAmbience(0, 10),
                        () => this.startBigWinMusicLoop()
                    ])
                }
                tl.add([
                    () => HarlequinGameModuleConfig.countUpView.getWinStepAnimation(this._countTo, this._countTo, 0, undefined, 15),
                    //()=>this.startCountUpSound()
                ]);

            //const winTextEnd:TimelineLite = HarlequinGameModuleConfig.winTextView.getEndAnimation(this._toRatioConfig);
            //tl.add(winTextEnd,"+=0.0");
            return tl;
        }

        return null; //tl;
    }

}